import { IgenomicsAction } from '../../../core/interfaces/genomics-action.interface';
import * as immutable from 'immutable';
import { TEST_META_ACTIONS } from '../constants/test-meta.constants';
import { IDisplayElement } from '../interfaces/test-header-elements.interface';


export interface ItestMetaState {
  config: {
    displayElements: immutable.Map<string, Array<IDisplayElement>>;
  };
}

const InitTestMetaState: ItestMetaState = {
  config: {
    displayElements: immutable.Map<string, Array<IDisplayElement>>()
  }
};

export function testMetaReducer(state: ItestMetaState = InitTestMetaState, action: IgenomicsAction): ItestMetaState {
  let newState;
  switch (action.type) {
    case TEST_META_ACTIONS.SET_HEADER_DISPLAY_CONFIG:
      newState = Object.assign({ }, state);
      newState.config = Object.assign({ }, newState.config);
      newState.config.displayElements = newState.config.displayElements.set(action.payload['elementName'], action.payload['config']);
      return newState;
    default:
      return state;
  }
}
